export const mapIntentToDataTable = (data) => {
  let result = data.map((item) => ({
    ...item,
  }));

  return result;
};

export const ttsIntentColumns = [
  { key: "eventNamespace", label: "EventNamespace", align: "center" },
  { key: "eventName", label: "EventName", align: "center" },
  { key: "contextNamespace", label: "ContextNamespace", align: "center" },
  { key: "contextName", label: "ContextName", align: "center" },
  { key: "type", label: "type", align: "center" },
  { key: "skillName", label: "SkillName", align: "center" },
];
